var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.3229V4.02713C2 2.60013 2 1.88663 2.43934 1.44332C2.87868 1 3.58579 1 5 1H7C8.4142 1 9.1213 1 9.56065 1.44332C10 1.88663 10 2.60013 10 4.02713V9.3229C10 10.0787 10 10.4567 9.769 10.6054C9.39155 10.8486 8.80805 10.3387 8.51455 10.1537C8.27205 10.0007 8.15085 9.92425 8.01625 9.91985C7.87085 9.91505 7.74745 9.9884 7.48545 10.1537L6.53 10.7562C6.27225 10.9187 6.1434 11 6 11C5.8566 11 5.72775 10.9187 5.47 10.7562L4.51456 10.1537C4.27207 10.0007 4.15083 9.92425 4.01626 9.91985C3.87086 9.91505 3.74747 9.9884 3.48544 10.1537C3.19197 10.3387 2.60843 10.8486 2.23097 10.6054C2 10.4567 2 10.0787 2 9.3229Z",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5H4",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5H4",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.9f6c9f78a7df07898f8bb255627c8c44.svg";
export { ForwardRef as ReactComponent };